function isSupportedComponentNode(node) {
  switch (node.nodeType) {
    case "iframe-component":
    case "iframe-component.component-framework":
    case "component-framework.i-ark":
    case "component-framework.i-guide":
    case "component-framework.image-hotspots":
    case "component-framework.flashcard":
    case "component-framework.geogebra":
    case "component-framework.opgavekomplekset":
    case "image-component":
    case "audio-component":
    case "23-video-component":
    case "slider-component":
    case "text-component":
    case "cta-component":
    case "split-component":
      return true;
    default:
      return false;
  }
}

export { isSupportedComponentNode };
//# sourceMappingURL=typings.component-nodes.js.map
